import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

// components
import Gallery from "components/ListingNew/ListingNormal/GalleryCarouselPopup";

//helpers
import { getImg } from "helpers/getCloudinaryImage";

// assets
import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";
import { SvgShare } from "assets/icons/js/SvgShare";

// styles
import "./style.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useTheme } from "components/ListingNew/ListingTheme";

interface image {
	ImgId: string;
	version: string;
	order: string;
}

interface PageProps {
	images: image[];
	height?: string;
	width?: string;
	quality?: string;
	closeGalleryPage: () => void;
	openSharePopup: () => void;
	guestImages: any;
}

const ListingImageGalleryPage = ({
	images,
	height,
	width,
	quality,
	closeGalleryPage,
	openSharePopup,
	guestImages,
}: PageProps) => {
	//---gallery carousel popup stuff
	const [openGalleryCarousel, setOpenGalleryCarousel] = useState(false);
	const [clickedImageIndex, setClickedImageIndex] = useState(0);
	const [imageToggle, setImageToggle] = useState(0);

	const openGalleryCarouselAndSetIndex = (index: number) => {
		setOpenGalleryCarousel(true);
		setClickedImageIndex(index);
	};

	useEffect(() => {
		document.body.style.overflowY = "hidden";
		return () => {
			document.body.style.overflowY = "auto";
		};
	}, []);

	const theme = useTheme();
	const search = new URLSearchParams(window.location.search);

	useEffect(() => {
		if (search.get("memories")) {
			setImageToggle(1);
		}
	}, [guestImages]);

	return (
		<div
			className="listing_image_gallery_page__container-main"
			style={{ background: theme?.background }}
		>
			<div
				className="listing_image_gallery_page__container-header"
				style={{ background: theme?.background }}
			>
				<button
					aria-label="back-arrow"
					className="listing_image_gallery_page__header-btn go-back-btn"
					onClick={closeGalleryPage}
				>
					<SvgRightArrow />
					<p style={{ color: theme?.primaryTextColor }}>Go back</p>
				</button>
				<button
					aria-label="share-button"
					className="listing_image_gallery_page__header-btn"
					onClick={() => openSharePopup()}
				>
					<SvgShare />
					<p style={{ color: theme?.primaryTextColor }}>Share</p>
				</button>
			</div>
			{guestImages && guestImages?.length && (
				<div className="image_toggle-btn-wrapper">
					<button
						className={`image_toggle-btn ${
							imageToggle === 0 && "active-image-btn"
						}`}
						onClick={() => {
							setImageToggle(0);
						}}
						style={{
							borderColor: theme?.baseTextColor,
							color: theme?.baseTextColor,
						}}
					>
						Villa Images
					</button>
					<button
						className={`image_toggle-btn ${
							imageToggle === 1 && "active-image-btn"
						}`}
						onClick={() => {
							setImageToggle(1);
						}}
						style={{
							borderColor: theme?.baseTextColor,
							color: theme?.baseTextColor,
						}}
					>
						Guest Images
					</button>
				</div>
			)}
			{imageToggle === 0 ? (
				<div className="listing_image_gallery_page__container-content">
					{images?.map((image, index) => {
						const src: string = getImg({
							id: image,
							quality: quality ? quality : "40",
							height: height,
							width: width,
						});
						return (
							<div className="listing_image_gallery_page__photo">
								<LazyLoadImage
									src={src}
									effect="blur"
									key={index}
									alt="home"
									onClick={() => {
										openGalleryCarouselAndSetIndex(index);
									}}
								/>
							</div>
						);
					})}
					{openGalleryCarousel && (
						<Gallery
							open={openGalleryCarousel}
							setOpen={setOpenGalleryCarousel}
							images={images}
							clickedImageIndex={clickedImageIndex}
						/>
					)}
				</div>
			) : (
				<div className="listing_image_memories-wrapper">
					{guestImages.map((ele: any) => {
						return (
							<div className="guest-image-wrapper" key={ele.VISUAL_MEDIA}>
								{ele.TYPE === "image" && (
									<LazyLoadImage
										src={
											"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/" +
											ele.VISUAL_MEDIA +
											"?tr=q-50,w-1000,h-auto,f-webp"
										}
										effect="blur"
										loading="lazy"
										alt=""
									/>
								)}
								{ele.TYPE === "video" && (
									<video
										src={
											"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/video/upload/" +
											ele.VISUAL_MEDIA +
											"?tr=q-50"
										}
										controls
									/>
								)}
								<span>
									{ele.GUEST_NAME} &#8226;{" "}
									{new Date(ele.CREATED_ON).toDateString()}
								</span>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default ListingImageGalleryPage;
